/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {IAB_TAXONOMY} from './iab-taxonomy';

export interface PreparedIabCategory {
  id: string;
  value: string;
  lowerCase: string;
  filteredLowerCase: string;
  words: string[];
  order?: number;
}

export const PREPARED_IAB_TAXONOMY: PreparedIabCategory[] = _.map(IAB_TAXONOMY, (iab: any) => {
  const lowerCase = iab.value.toLowerCase();
  return {
    ...iab,
    lowerCase,
    filteredLowerCase: lowerCase.replace(/and/gi, ''),
    words: _.filter(lowerCase.replace(/and/gi, '').split(' '), (word: string) => word.length >= 3)
  };
});

export function normalizeIabCategoryIds(categories: any): string[] {
  return _.map(categories || [], (iab: any) => _.get(iab, 'id', iab));
}

export function findIabCategoriesByIds(categoryIds: string[]): PreparedIabCategory[] {
  if (!categoryIds?.length) {
    return [];
  }
  return _.filter(PREPARED_IAB_TAXONOMY, (iab) => categoryIds.indexOf(iab.id) > -1);
}

export function searchIabCategories(search: string, limit = 150): PreparedIabCategory[] {
  const searchString = (search || '').toLowerCase();
  const filtered = !searchString
    ? PREPARED_IAB_TAXONOMY
    : _.orderBy(
      _.filter(PREPARED_IAB_TAXONOMY, (iab) => iab.lowerCase.indexOf(searchString) > -1),
      (iab) => {
        const initPosition = Math.max(10 - iab.lowerCase.indexOf(searchString), 0);
        const repeated = iab.filteredLowerCase.split(searchString).length - 1;
        const startOfWords = _.filter(iab.words, (word) => word.indexOf(searchString) === 0).length;
        return 1000 - (startOfWords * 10 + repeated * 2 + initPosition);
      }
    );
  return filtered.slice(0, limit);
}

export function seedIabSearchResults(
  currentResults: PreparedIabCategory[],
  categoryIds: string[]
): PreparedIabCategory[] {
  const selected = findIabCategoriesByIds(categoryIds);
  return _.uniqBy([...selected, ...currentResults], 'id');
}
